export const SET_ERROR = "supportui/App/SET_ERROR";
